// Synthesised sound cues — warm, soft, wooden. Kept gentle to match the tone.
import type { Scene } from '../engine/webgpu.js';

type Snd = Parameters<Scene['sound']['play']>[0];

export const SFX: Record<string, Snd> = {
  saw:    { type: 'noise', duration: 0.22, volume: 0.25, attack: 0.02, release: 0.12, filter: { type: 'bandpass', freq: 1200, q: 2 } },
  hammer: { type: 'noise', duration: 0.12, volume: 0.3, release: 0.08, curve: 'exponential', filter: { type: 'lowpass', freq: 900 } },
  chopGood: { type: 'triangle', freq: 320, freqEnd: 180, duration: 0.2, volume: 0.3, curve: 'exponential' },
  chop:   { type: 'noise', duration: 0.16, volume: 0.28, release: 0.1, filter: { type: 'lowpass', freq: 700 } },
  pickup: { type: 'sine', notes: 'C5 E5', step: 0.08, volume: 0.25 },
  craft:  { type: 'sine', notes: 'C5 E5 G5', step: 0.1, volume: 0.28 },
  masterwork: { type: 'sine', notes: 'C5 E5 G5 C6', step: 0.12, volume: 0.32 },
  deliver:{ type: 'triangle', notes: 'G4 C5', step: 0.11, volume: 0.28 },
  chime:  { type: 'sine', notes: 'E5 G5 C6', step: 0.14, volume: 0.24 },
  page:   { type: 'noise', duration: 0.09, volume: 0.15, release: 0.06, filter: { type: 'highpass', freq: 1800 } },
  bless:  { type: 'sine', notes: 'C5 E5 G5:2', step: 0.18, volume: 0.22 },
  select: { type: 'sine', freq: 660, duration: 0.06, volume: 0.15 },
  door:   { type: 'noise', duration: 0.14, volume: 0.18, release: 0.09, curve: 'exponential', filter: { type: 'lowpass', freq: 420 } },
  water:  { type: 'sine', freq: 500, freqEnd: 300, duration: 0.18, volume: 0.18, curve: 'exponential' },
  scroll: { type: 'sine', notes: 'A4 D5 F5', step: 0.12, volume: 0.2 },
  chapter:{ type: 'sine', notes: 'C5 E5 G5 C6 G5', step: 0.16, volume: 0.26 },
};

export function play(scene: Scene, name: keyof typeof SFX): void {
  scene.sound.play(SFX[name]);
}
